import { render, staticRenderFns } from "./ScaleButtons.vue?vue&type=template&id=d63c841a&"
import script from "./ScaleButtons.vue?vue&type=script&lang=js&"
export * from "./ScaleButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ScaleButtons.vue"
export default component.exports